// Combining diacritical marks (U+0300-U+036F), stripped after NFKD splits accents off their letters.
const DIACRITICS_PATTERN: RegExp = /[̀-ͯ]/g;
const NON_SLUG_PATTERN: RegExp = /[^a-z0-9]+/g;
// eslint-disable-next-line sonarjs/slow-regex -- linear: one quantifier per alternation branch, no catastrophic backtracking
const EDGE_DASH_PATTERN: RegExp = /^-+|-+$/g;

export function slugify(value: string): string {
  return value
    .normalize('NFKD')
    .replace(DIACRITICS_PATTERN, '')
    .toLowerCase()
    .replace(NON_SLUG_PATTERN, '-')
    .replace(EDGE_DASH_PATTERN, '');
}
